"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _SidebarLink = _interopRequireDefault(require("../SidebarLink"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
require("./themes/DefaultTheme.css");
var theme = {
  "sidebar-list": "DefaultTheme__sidebar-list___ntZE1",
  "sidebarList": "DefaultTheme__sidebar-list___ntZE1"
};
/**
 * A line to separate two sections in Sidebar.
 */
var SidebarGroup = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(SidebarGroup, _React$PureComponent);
  function SidebarGroup(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, SidebarGroup);
    _this = _callSuper(this, SidebarGroup, [props]);

    // Validate that child elements are only SidebarLinks
    _react["default"].Children.forEach(_this.props.children, function (child) {
      if (child.type !== _SidebarLink["default"]) {
        throw new Error("Tag <".concat(child.type, "> is not supported inside of a SidebarGroup. Only <SidebarLink>s are allowed."));
      }
    });
    return _this;
  }
  (0, _createClass2["default"])(SidebarGroup, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: theme.sidebarList
      }, children);
    }
  }]);
  return SidebarGroup;
}(_react["default"].PureComponent);
//# sourceMappingURL=index.js.map